export default __webpack_public_path__ + "static/media/headphones-L.01846ed9.svg";